import { render, staticRenderFns } from "./_Alert.vue?vue&type=template&id=27f70928"
import script from "./_Alert.vue?vue&type=script&lang=js"
export * from "./_Alert.vue?vue&type=script&lang=js"
import style0 from "./_Alert.vue?vue&type=style&index=0&id=27f70928&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports